import { Common, OrderData, Promise, Realty, services } from '@ambita/ambita-components-core';
import { PRODUCTS_CADASTRE_REPORT } from '../constants/common';
import { CadastreReportsToMount } from '../typings/CadastreReport';
import { Order } from '../typings/Order';
import { fetchOrderWhichRequiresSensitiveInfoAccess, getProductOrderData } from './common';

const { filters } = services;

export const fetchReportData = (orderId: string, productCode: string): Promise<any> => {
  return fetchOrderWhichRequiresSensitiveInfoAccess(orderId).then((order: Order) => ({
    orderData: getProductOrderData(productCode, order)
  }));
};

export const isCadastreReportProduct = (product: string): boolean => {
  return product in PRODUCTS_CADASTRE_REPORT;
};

export const getCadastreReportsToMount = (orderData: OrderData.Data): CadastreReportsToMount => {
  const filteredProducts = orderData.products.filter(isCadastreReportProduct);

  return filteredProducts.reduce((accumulator, productCode) => {
    accumulator[productCode] = PRODUCTS_CADASTRE_REPORT[productCode];

    return accumulator;
  }, {});
};

export const createAddress = (item: any): string => {
  if (!item) {
    return '';
  }

  let address = item.streetName || item.street || item.alternativeAddress || '';
  address += ' ';
  address += item.addressNumber || '';
  address += item.letter || '';

  if (address.trim().length > 0) {
    address += ', ';
  }

  address += filters.padLeft(item.postalCode, 4, '0') + ' ' + item.postalPlace;

  return address;
};

export const getDsfState = (dsfState: Common.Status | string): string => {
  if (typeof dsfState === 'undefined') {
    return;
  } else if (typeof dsfState === 'string') {
    return dsfState;
  } else {
    return dsfState.text;
  }
};

export const getAddressFromOwner = (owner: Realty.ApiPerson): string => {
  return owner.businessAddress || createAddress(owner.location) || getDsfState(owner.dsfState);
};
